/*
 * Copyright (c) 2024 Ask Sage, Inc. All rights reserved.
 * This software is the confidential and proprietary information of Ask Sage, Inc.
 * You shall not disclose such confidential information and shall use it only in
 * accordance with the terms of the license agreement you entered into with Ask Sage, Inc.
 * THIS SOFTWARE IS PROVIDED "AS IS" AND ANY EXPRESSED OR IMPLIED WARRANTIES,
 * INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL ASK SAGE, INC.
 * OR ITS CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT
 * OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
 * STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
 * OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * You may not use this software except in compliance with the License.
 * You may not modify, reverse engineer, or redistribute this software.
 */
import React, { useState, useEffect } from 'react';
import * as default_data from '../config.js'
import { isPaid, getUser, getToken } from '../AuthService.js';
import Modal from 'react-modal';
import AddAPIKey from './AddAPIKey.js'
import { unEscapeHTML } from '../Utils/text_functions.js'
import { FiTrash2 } from 'react-icons/fi';
import * as log from 'loglevel'
import { CustomDialog } from '../Components/CustomDialog/CustomDialog.js';
import { Button } from '../Components/Button.js';
import { Stack, Typography, useTheme } from '@mui/material';
import { ApiKeysVignette } from './ApiKeyVignette.js';

const APIKeysList = ({ triggerAPIKeysList, setTriggerAPIKeysList }) => {

  const [APIKeys, setAPIKeys] = useState([]);
  const [user_id, setUserId] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [triggerAddAPIKeys, setTriggerAddAPIKeys] = useState(0);
  var loaded_static = false;
  const theme = useTheme();

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function addAPIKeys() {
    setTriggerAddAPIKeys(1)
  }

  function closeModal() {
    setTriggerAPIKeysList(0);
    setIsOpen(false);
  }

  function deleteClick(key) {
    key = key.toString();

    if(key == null || key == '') {
      return;
    }

    var token = getToken()
    if(token === false) {
      return;
    }

    var user = getUser()

    if(user === false || user == null) {
       window.location = '/login';
       return;
    }
    setUserId(user.id)
  
    fetch(default_data.default_user_service_url_no_cac + '/user-api-key', {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },        
      body: JSON.stringify({
        id: key
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if(data.status != 200) {
            return;
        }
        loadAPIKeys()
      })
      .catch(error => {
        console.log(error);
      });    
  }

  function loadAPIKeys() {
    var token = getToken()
    if(token === false) {
      return;
    }

    if(!isPaid()) {
      return;
    }

    var user = getUser()

    if(user === false || user == null) {
       window.location = '/login';
       return;
    }
    setUserId(user.id)    
  
    fetch(default_data.default_user_service_url_no_cac + '/get-user-api-keys', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-access-tokens': `${token}`
      },        
      body: JSON.stringify({
      })
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('An error occurred while getting data.');
      })
      .then(data => {
        if(data.status != 200) {
            return;
        }
        data = data.response;
        setAPIKeys(data);
      })
      .catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (triggerAPIKeysList) {
      if (triggerAPIKeysList === 1) {
        setIsOpen(true)
      }
    }
  }, [triggerAPIKeysList]);

  useEffect(() => {

    if(loaded || loaded_static) {
      return;
    }

    setLoaded(true)
    loaded_static = true;

    loadAPIKeys()

    }, [])
    
    const DisplayData = () => {
      return (APIKeys.map(
      (info)=>{ 
          return(
            <ApiKeysVignette key={info.id} info={info} deleteClick={deleteClick} />
          )
      }));      
    }

  return (
    <CustomDialog
      open={modalIsOpen}
      onClose={closeModal}
      maxWidth="md"
      fullWidth
      title="Your API Keys"
      subtitle="API key access requires a paid subscription"
      allowEscape={true}          
    >
      <Button size='small' onClick={addAPIKeys}>Create New API Key</Button>
      <Stack spacing={0} direction={'column'} width={'100%'} marginY={2}>
        <Typography fontSize={'14px'} color={theme.palette.text.secondary}>
          Ask Sage documentation: <a style={{color: theme.palette.text.secondary }} href={default_data.default_custom_docs_url} rel="noreferrer" target="_blank">{default_data.default_custom_docs_url}</a>
        </Typography>
        <Typography fontSize={'14px'} color={theme.palette.text.secondary}>
          Ask Sage Python API Client: <a style={{color: theme.palette.text.secondary }} rel="noreferrer" href="https://pypi.org/project/asksageclient/" target="_blank">https://pypi.org/project/asksageclient/</a>
        </Typography>
      </Stack>

      <div className="api-keys-container">              
        { 
          (APIKeys.length === 0) ?
            <div className="loading" style={{fontSize: '20px'}}>No existing key.</div> 
            : 
            <DisplayData />
        }
        
      </div>
      <AddAPIKey
        loadAPIKeys={loadAPIKeys}
        setTriggerAddAPIKeys={setTriggerAddAPIKeys}
        triggerAddAPIKeys={triggerAddAPIKeys}
      />
    </CustomDialog>
  );
}
export default APIKeysList;
